import Alpine from 'alpinejs';
import persist from '@alpinejs/persist'

// Stores
import deliveryPackageStore from "./deliveryPackageStore";

window.Alpine = Alpine;

Alpine.plugin(persist);

Alpine.data('deliveryPackages', deliveryPackageStore)

Alpine.start()
